<template>
  <div class="popup-background">
    <div class="popup-window">
      <div class="popup-header">
        <h1 class="popup-title">{{ capitalize($t('actions.sort')) }}</h1>
      </div>
      <div v-if="validationError" class="form-row">
        <div class="validationerror-block">{{ validationError }}</div>
      </div>
      <div class="popup-form">
        <div class="form-row">
          <label>{{ capitalize($t('actions.sort')) }}:</label>
          <custom-select
            v-model="sortField"
            :options="sortFieldOptions"
            :disableLabelTranslation="true"
            :flexwidth="true"
          ></custom-select>
        </div>
        <div class="form-row form-row-toggle">
          <label>{{ capitalize($t('sorting.order.' + sortOrder)) }}</label>
          <toggle v-model="isDescending"></toggle>
        </div>
      </div>
      <div class="form-row">
        <button @click="close" class="input-button" :disabled="sending">{{ capitalize($t('actions.cancel')) }}</button>
        <button @click="send" class="input-button input-button-primary" :disabled="sending">{{ capitalize($t('actions.confirm')) }}</button>
      </div>
      <div class="popup-close" @click="close">&#10006;</div>
    </div>
  </div>
</template>

<script>
import CustomSelect from '@/components/form-elements/CustomSelect'
import Toggle from '@/components/form-elements/Toggle'

export default {
  name: 'modal-bookshelf-sort',
  emits: ['close'],
  computed: {
    sortOrder () {
      return this.isDescending ? 'descending' : 'ascending'
    },
    sortFieldOptions () {
      return this.sortFieldOptionKeys.map(option => ({
        ...option,
        label: this.capitalize(this.$t(option.labelKey))
      }))
    }
  },
  data: () => ({
    bookshelfId: null,
    sortField: 'name',
    isDescending: false,
    sortFieldOptionKeys: [
      { labelKey: 'bookshelf.sortField.title', value: 'title' },
      { labelKey: 'bookshelf.sortField.yearOfPublication', value: 'yearofpublication' },
      { labelKey: 'bookshelf.sortField.lastAdded', value: 'created' }
    ],
    validationError: null,
    sending: false
  }),
  methods: {
    reset () {
      this.bookshelfId = null
      this.sortField = 'name'
      this.isDescending = false
      this.validationError = null
      this.sending = false
    },
    load (bookshelfData = null) {
      this.reset()

      if (!bookshelfData?.id) {
        this.close()
        return
      }

      this.bookshelfId = bookshelfData.id
    },
    async send () {
      if (this.sending || !this.bookshelfId) return

      this.validationError = null
      this.sending = true

      const result = await this.$store.dispatch('bookshelfStore/sortBookshelf', {
        bookshelfId: this.bookshelfId,
        sortField: this.sortField,
        sortOrder: this.sortOrder
      })

      if (result.error) {
        this.sending = false
        this.validationError = result.error
        return false
      }

      await this.$store.dispatch('bookshelfStore/fetchUserBookshelves')

      this.sending = false
      this.close()
      window.location.reload()
    },
    close () {
      this.$emit('close')
    }
  },
  components: {
    'custom-select': CustomSelect,
    toggle: Toggle
  }
}
</script>

<style lang="scss" scoped>
  .form-row {
    margin: 10px 0;

    label {
      display: block;
    }
  }

  .form-row-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    label {
      margin: 0;
    }
  }

  .validationerror-block {
    padding: 10px;
    border: 1px solid red;
    border-radius: 4px;
    background-color: rgba(255, 0, 0, 0.1);
  }
</style>
